<template>
  <div class="main-box">
    <a @click="showModal">设置</a>
    <a-modal
      title='设置'
      okText="保存"
      :visible='modalVisible'
      :confirmLoading='submitLoading'
      width='820px'
      @ok="submitEvent"
      @cancel="cancelEvent"
    >
      <a-form-model
        :label-col="{ span: 5}"
        :wrapper-col="{ span: 6}"
        :model="ruleForm"
        :rules="tabRule"
        ref="ruleForm"
      >
        <a-form-model-item
          label="加价设置"
          required
          :label-col="{ span: 4}"
          :wrapper-col="{ span: 16}"
        >
          <span style="color: red">说明：修改加价比例，保存后，需手动全量更新产品</span>
        </a-form-model-item>
        <div style="padding-left: 10px">
          <a-form-model-item label="同行价加价比例" prop="tradePriceRatio">
            <a-input
              placeholder="请输入"
              v-model.number="ruleForm.tradePriceRatio"
              :maxLength="4"
              addon-after="%"
            />
          </a-form-model-item>
          <a-form-model-item label="销售价加价比例" prop="salePriceRatio">
            <a-input
              placeholder="请输入"
              v-model.number="ruleForm.salePriceRatio"
              :maxLength="4"
              addon-after="%"
            />
          </a-form-model-item>
          <a-form-model-item label="市场价加价比例" prop="marketPriceRatio">
            <a-input
              placeholder="请输入"
              v-model.number="ruleForm.marketPriceRatio"
              :maxLength="4"
              addon-after="%"
            />
          </a-form-model-item>
          <a-form-model-item label="采购价加价比例" prop="purchasePriceRatio">
            <a-input
              placeholder="请输入"
              v-model.number="ruleForm.purchasePriceRatio"
              :maxLength="4"
              addon-after="%"
            />
          </a-form-model-item>
        </div>
        <div style="padding: 0 50px;color: #aaaaaa">
          <p style="margin: 0">说明：1、金额（销售、同行、市场、采购） =商品金额 （途牛） * 价格百分比：</p>
          <p style="margin: 0 0 0 60px"> 例： 销售价要加价20% 需设置为 120%</p>
          <p style="margin: 0 0 0 42px">2、前端商品显示价格时，显示整数，小数位 按四舍五入</p>
          <p style="margin: 0 0 0 42px">3、佣金金额 = 销售加价金额-同行加价金额</p>
        </div>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'TuNiuConfig',
  data() {
    return {
      modalVisible: false,
      ruleForm: {},
      tabRule: {
        tradePriceRatio: [
          { required: true, message: '请输入同行价加价比例', trigger: ['blur', 'change'] },
          // { pattern: /^(?:[1-9]|[1-9][0-9]|[1-4][0-9]{2}|500)$/, message: "只能输入小于等于500的正整数",trigger: ['blur', 'change']},
          { type: 'number', min: 100, max: 1000, message: '只能输入100-1000之间的整数', trigger: ['blur', 'change'] }
        ],
        salePriceRatio: [
          { required: true, message: '请输入销售价加价比例', trigger: ['blur', 'change'] },
          // { pattern: /^(?:[1-9]|[1-9][0-9]|[1-4][0-9]{2}|500)$/, message: "只能输入小于等于500的正整数",trigger: ['blur', 'change']},
          { type: 'number', min: 100, max: 1000, message: '只能输入100-1000之间的整数', trigger: ['blur', 'change'] },
          { validator: this.checkAdvicePrice, trigger: ['blur', 'change'] }
        ],
        marketPriceRatio: [
          { required: true, message: '请输入市场价加价比例', trigger: ['blur', 'change'] },
          // { pattern: /^(?:[1-9]|[1-9][0-9]|[1-4][0-9]{2}|500)$/, message: "只能输入小于等于500的正整数",trigger: ['blur', 'change']},
          { type: 'number', min: 100, max: 1000, message: '只能输入100-1000之间的整数', trigger: ['blur', 'change'] }
        ],
        purchasePriceRatio: [
          { required: true, message: '请输入采购价加价比例', trigger: ['blur', 'change'] },
          // { pattern: /^(?:[1-9]|[1-9][0-9]|[1-4][0-9]{2}|500)$/, message: "只能输入小于等于500的正整数",trigger: ['blur', 'change']},
          { type: 'number', min: 100, max: 1000, message: '只能输入100-1000之间的整数', trigger: ['blur', 'change'] }
        ]
      },
      submitLoading: false
    }
  },
  methods: {
    getDetailInfo() {
      return new Promise(resolve => {
        this.ruleForm = {}
        this.getHttpServices().getServerApiService().post('/v2/tuniu/setting/query', {
          merchantId: this.$store.getters.userInfo.merchantId,
          platformId: this.getPlatformConfig().platformId
        }).then(res => {
          if (res) this.ruleForm = res
          resolve()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      })
    },
    checkAdvicePrice(rule, value, callback) {
      setTimeout(() => {
        if (Number(value) <= Number(this.ruleForm.tradePriceRatio)) {
          callback(new Error('销售价必须大于同行价'))
        } else {
          callback()
        }
      }, 200)
    },
    async showModal() {
      await this.getDetailInfo()
      this.modalVisible = true
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate()
      })
    },
    cancelEvent() {
      this.modalVisible = false
    },
    submitEvent() { //提交
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.updateRequest()
        } else {
          this.$message.error('请完善必要的信息')
        }
      })
    },
    updateRequest() {
      if (!this.submitLoading) {
        this.submitLoading = true
        this.getHttpServices().getServerApiService().post('/v2/tuniu/setting/save', {
          ...this.ruleForm,
          merchantId: this.$store.getters.userInfo.merchantId,
          platformId: this.getPlatformConfig().platformId,
          createTime: undefined,
          updateTime: undefined
        }).then(res => {
          this.$message.success('保存成功')
          this.cancelEvent()
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.main-box {
  display: inline-block;
}

::v-deep .ant-form-item {
  margin-bottom: 10px;
}

.content-box {
  position: relative;

  &:after {
    content: '× (销售价 - 同行价)';
    font-size: 14px;
    color: #AAAAAA;
    position: absolute;
    right: -125px;
    top: -4px;
  }
}
</style>
